module.exports = __webpack_public_path__ + "static/khalil-headshot-long-dce89e37af081883aeaee4ec0fa6c6ab.png";